import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { SidebarItem } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

const STORAGE_KEY = 'localproxy.basicAuth';

export function LogoutSidebarItem() {
  const identityApi = useApi(identityApiRef);

  const onLogout = async () => {
    // 1) Clear your persisted Basic Auth
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }

    // 2) Clear Backstage identity/session
    await identityApi.signOut();

    // 3) Hard reload so the app re-evaluates auth and shows SignInPage
    window.location.assign('/');
  };

  return (
    <SidebarItem
      icon={ExitToAppIcon}
      text="Logout"
      onClick={onLogout}
    />
  );
}
